export default {"src":"/_next/static/media/0x900db999074d9277c5da2a43f252d74366230da0.81307756.svg","height":1932,"width":1930,"blurWidth":0,"blurHeight":0};